import { Box, Stack, styled } from "@tm/components"

export const StyledModuleHeader = styled(Stack, {
    name: "DirectSearchModuleHeader",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})(({ theme }) => ({
    flexDirection: "row",
    alignItems: "flex-end",
    padding: `${theme.spacing(0.75)} ${theme.spacing(2)}`,
    backgroundColor: theme.overwrites?.components?.partListV2?.backgroundColor,
}))

export const SearchFieldContainer = styled(Stack)(({ theme }) => ({
    flexDirection: "row",
    gap: theme.spacing(1),
}))

export const TileWrapper = styled(Box)(() => ({
    display: "grid",
    // dimensions transferred from the mockup (https://zpl.io/WQQnr0j)
    gridAutoRows: "400px",
    gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))",
    columnGap: "1rem",
    padding: "0.8rem 0 0.2rem 0",
    alignItems: "stretch",
    justifyContent: "center",
}))
